import template from './cameraAudioLiveFeed.html';

/* @ngInject */
function CameraAudioLiveFeedController($interval, $log, CameraService) {
  const vm = this;
  let getFeedInterval;

  // //////////////// //
  // PUBLIC VARIABLES //
  // //////////////// //
  vm.values = [];
  vm.pollingLabel = 'Start';

  // //////////////// //
  // PUBLIC FUNCTIONS //
  // //////////////// //
  vm.$onDestroy = destroy;
  vm.getLiveDecibelFeed = getLiveDecibelFeed;

  function destroy() {
    if (getFeedInterval) {
      $interval.cancel(getFeedInterval);
      getFeedInterval = null;
    }
  }


  function getLiveDecibelFeed() {
    // do stuff to get the live decibel feed
    if (getFeedInterval) {
      $interval.cancel(getFeedInterval);
      getFeedInterval = null;
      vm.pollingLabel = 'Start';
    } else {
      getFeedInterval = $interval(() => {
        CameraService.getAudioLevel(vm.camera.id)
          .then((success) => {

            /**
             * this line converts the decibel reading into a percentage of the
             * maximum decibel level.
             * While looking at the camera code, we concluded that the minimum
             * decibel level is -90dB and max is 0dB. So here we convert it to
             * a positive number (+90), and then calculate the percentage of
             * the max.
             */
            vm.values.unshift({
              ratio: ((parseInt(success.data.decibel, 10) + 90) / 90) * 100,
              reading: parseInt(success.data.decibel, 10)
            });
          })
          .catch((res) => {
            $log.error('Error: ', res.error);
          });
      }, 1000);
      vm.pollingLabel = 'Stop';
    }
  }
}

export default {
  name: 'cameraAudioLiveFeed',
  template,
  controller: CameraAudioLiveFeedController,
  controllerAs: 'CamAudLiveFeedCtrl',
  bindings: {
    camera: '<',
    alarmLevel: '<'
  }
};
